// extracted by mini-css-extract-plugin
export default {"top":"ballon_top__sGqkO"};